import CopyLinkSection from './CopyLinkSection';
import { CopyLinkSectionProps, CopyLinkSectionValueProps } from './types';

export type { CopyLinkSectionProps, CopyLinkSectionValueProps };
export default CopyLinkSection;
